module.exports = __webpack_public_path__ + "img/cash.3ffc7097.png";